import { extend } from 'vee-validate'
import * as rules from 'vee-validate/dist/rules'

Object.keys(rules).forEach(key => {
  extend(key, rules[key])
})
